export default "__VITE_ASSET__sZrEV7eT__"